import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BackendService } from './backend.service';
import { MainService } from './main.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {

  constructor(private backendService: BackendService, private mainService: MainService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    console.log(`intercepting http request to url ${request.url}`);

    /*
    const newRequest = request.clone({
      headers: this.gateway.sessionId != null ? request.headers.set('Cookie', `JSESSIONID=${this.gateway.sessionId}`) : request.headers
    });
    */

    const newRequest = request.clone({
      headers: this.backendService.sessionId != null ?
        request.headers
          .set('APP-SESSION-ID', `${this.backendService.sessionId}`)
          .set('COD-SEDE', `${this.mainService.getSede()}`)
        : request.headers
    });

    this.mainService.setLoading(true);

    return next.handle(newRequest)
      .pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            this.mainService.setLoading(false);
          }
        })
      )
    /*
    .pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          console.log(`intercepted response is HttpResponse`);
          const response: HttpResponse<any> = event;
          console.log(`intercepted response headers length = ${response.headers.keys.length}`);
          for (let it = 0; it < response.headers.keys.length; it++) {
            const name = response.headers.keys[it];
            const value = response.headers.get(name);
            console.log(`received header ${name} = ${value}`);
          }
        }
      })
    ) */ ;

  }

}
